
import { useMemo } from 'react';
import { contentLinker } from '@/services/contentLinker';
import { sanitizeHtml } from '@/utils/sanitizeHtml';

interface AutoLinkedContentProps {
  content: string;
  className?: string;
}

const AutoLinkedContent = ({ content, className }: AutoLinkedContentProps) => {
  const processedContent = useMemo(() => {
    const linkedContent = contentLinker.processContent(content);
    return sanitizeHtml(linkedContent, {
      allowLinks: true,
      allowBasicFormatting: true,
      allowImages: true
    });
  }, [content]);

  return (
    <div 
      className={className}
      dangerouslySetInnerHTML={{ __html: processedContent }} 
    />
  );
};

export default AutoLinkedContent;
